import { formatRoleLabel } from './editRequestFormat';

/** Pill colour per side, following the Figma review card: the brand side is
 *  brand-violet, admin is neutral, creator/talent are informational. Keyed on
 *  the human label so every raw role that maps to the same label shares a pill. */
const ROLE_BADGE_STYLE: Record<string, string> = {
  'Brand manager': 'bg-violet-100 text-violet-700',
  Admin: 'bg-emerald-100 text-emerald-700',
  Creator: 'bg-sky-100 text-sky-700',
  'Talent manager': 'bg-amber-100 text-amber-700',
};

/** Small pill naming which side a comment came from — "Brand manager" / "Admin".
 *  Renders nothing for roles that have no display label, so callers can drop it
 *  inline without guarding. */
export function RoleBadge({ role }: { role: string | undefined }) {
  const label = formatRoleLabel(role);
  if (!label) return null;
  const style = ROLE_BADGE_STYLE[label] ?? 'bg-muted text-muted-foreground';
  return <span className={`shrink-0 rounded-full px-2 py-0.5 text-caption-medium ${style}`}>{label}</span>;
}
